export default __webpack_public_path__ + "static/media/siteLogo.020f7aa2.svg";